import React from "react";

export const TableEditIcon = () => {
  return (
    <svg
      data-testid="table-edit-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        data-testid="edit-circle"
        cx="8"
        cy="2.5"
        r="1.5"
        fill="#0068FF"
      />
      <circle data-testid="edit-circle" cx="8" cy="8" r="1.5" fill="#0068FF" />
      <circle
        data-testid="edit-circle"
        cx="8"
        cy="13.5"
        r="1.5"
        fill="#0068FF"
      />
    </svg>
  );
};
